import { gql } from "@apollo/client";

export const GET_LEAGUE_PLAYERS = gql`
    query LeaguePlayers(
        $profileId: Int!
        $organizationId: Int
        $roleIds: [Int]
        $q: String
        $page: Int
        $pageSize: Int
    ) {
        leaguePlayers(
            profileId: $profileId
            organizationId: $organizationId
            roleIds: $roleIds
            q: $q
            page: $page
            pageSize: $pageSize
        ) {
            objects {
                id
                profileId
                fullName
                email
                phone
                gender
                dob
                organization {
                    id
                    name
                    slug
                }
                organizations {
                    id
                    name
                    slug
                }
                activeTeams {
                    id
                    name
                    slug
                }
                roles
                roleId
                roleIds
                logoUrl
            }
            page
            pages
            hasNext
            hasPrev
            totalCount
        }
    }
`;

export const GET_PLAYER_ORGANIZATIONS = gql`
    query PlayerOrganizations($profileId: Int!) {
        organizations(profileId: $profileId, page: 1, pageSize: 1000) {
            objects {
                id
                name
                slug
            }
        }
    }
`;
